import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon, ArrowLeftIcon } from 'lucide-react';
import { QUOTE_CHECKLIST } from '../data/site';
import { CATALOG, lowestPrice } from '../data/catalog';
import { MAIN_WHATSAPP_MESSAGE } from '../data/messages';
import { formatMXN } from '../utils/currency';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';
import { PerksStrip } from '../components/PerksStrip';
import { trackEvent } from '../utils/analytics';
export function Gracias() {
  useEffect(() => {
    trackEvent('thank_you_page_view');
  }, []);
  return <div className="min-h-screen w-full bg-white" data-id="element-367" data-mp="3fv9efyhq65zg">
      <SiteHeader data-id="element-368" data-mp="3ftg7sj743lrg" />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:py-20" data-id="element-369" data-mp="2s5ylv4aj3hwe">
        <CheckCircle2Icon className="h-11 w-11 text-signal-600" aria-hidden="true" data-id="element-370" data-mp="2s3vmvureeefj" />
        <h1 className="mt-4 font-display text-4xl font-bold leading-tight text-navy-900 sm:text-5xl" data-id="element-371" data-mp="2n6c7griyrvm0">
          Gracias. Ya recibimos tus datos.
        </h1>
        <p className="mt-3 text-base leading-relaxed text-steel-600" data-id="element-372" data-mp="2lb999wcgxemu">
          Para acelerar tu cotización, escríbenos ahora por WhatsApp. Te confirmamos precio, disponibilidad y fecha de
          entrega.
        </p>
        <WhatsAppButton message={MAIN_WHATSAPP_MESSAGE} label="Continuar por WhatsApp" location="pagina_gracias" intent="post_formulario" size="lg" className="mt-6" data-id="element-373" data-mp="2u31i62lugfpb" />

        <div className="mt-10 grid grid-cols-3 gap-3" data-id="element-374" data-mp="22f12up7pyxpy">
          {CATALOG.map(cat => <div key={cat.id} className="rounded-lg border border-steel-200 p-4" data-id="element-375" data-mp="26d76hod9gx6n">
              <p className="text-sm text-steel-600" data-id="element-376" data-mp="2bf6an0gtry4n">{cat.shortLabel}</p>
              <p className="font-display text-2xl font-semibold text-navy-900" data-id="element-377" data-mp="3hugoe6gqrh5u">desde {formatMXN(lowestPrice(cat))}</p>
            </div>)}
        </div>

        <div className="mt-6 rounded-xl bg-steel-50 p-5" data-id="element-378" data-mp="3mul8e6guyu0t">
          <h2 className="font-display text-xl font-semibold text-navy-900" data-id="element-379" data-mp="1mp7iio73i7bd">Ten a la mano estos datos</h2>
          <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-380" data-mp="1iodw5z9ax0kl">
            {QUOTE_CHECKLIST.map(item => <li key={item} className="text-[15px] text-navy-800" data-id="element-381" data-mp="1wnx3ipuag7vu">
                · {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-6" data-id="element-382" data-mp="13zhrmc6ge5oq">
          <PerksStrip tone="light" data-id="element-383" data-mp="140sqpyoyep9i" />
        </div>

        <Link to="/" className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-navy-700 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-accent-600" data-id="element-384" data-mp="z17uhw164v0h">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-385" data-mp="18yu9sjmdqokz" />
          Volver al cotizador
        </Link>
      </main>
      <SiteFooter data-id="element-386" data-mp="l88dfplqmsqt" />
    </div>;
}